import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const images = [
        { src: '/screen1.jpg', alt: 'App Screenshot 1' },
        { src: '/screen2.jpg', alt: 'App Screenshot 2' },
        { src: '/screen3.jpg', alt: 'App Screenshot 3' },
        { src: '/screen4.jpg', alt: 'App Screenshot 4' },
        { src: '/screen5.jpg', alt: 'App Screenshot 5' },
        { src: '/screen6.jpg', alt: 'App Screenshot 6' },
        { src: '/screen7.png', alt: 'App Screenshot 7' },
        { src: '/screen8.png', alt: 'App Screenshot 8' },
        { src: '/screen9.png', alt: 'App Screenshot 9' },
    ];

    // Auto-play functionality
    useEffect(() => {
        if (!isAutoPlaying) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 4000); // Change slide every 4 seconds

        return () => clearInterval(interval);
    }, [isAutoPlaying, images.length]);

    const goToSlide = (index) => {
        setCurrentIndex(index);
        setIsAutoPlaying(false);
        // Resume auto-play after 10 seconds of inactivity
        setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    const goToPrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        setIsAutoPlaying(false);
        setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsAutoPlaying(false);
        setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    return (
        <div className="carousel-container">
            <div className="carousel-wrapper">
                {/* Main carousel display */}
                <div className="carousel-main">
                    <button
                        className="carousel-nav carousel-nav-left"
                        onClick={goToPrevious}
                        aria-label="Previous slide"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>

                    <div className="carousel-slides">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className={`carousel-slide ${index === currentIndex ? 'active' : ''
                                    } ${index === (currentIndex - 1 + images.length) % images.length ? 'prev' : ''
                                    } ${index === (currentIndex + 1) % images.length ? 'next' : ''
                                    }`}
                            >
                                <div className="carousel-image-wrapper">
                                    <img
                                        src={image.src}
                                        alt={image.alt}
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className="carousel-nav carousel-nav-right"
                        onClick={goToNext}
                        aria-label="Next slide"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </button>
                </div>

                {/* Thumbnail navigation */}
                <div className="carousel-thumbnails">
                    {images.map((image, index) => (
                        <button
                            key={index}
                            className={`carousel-thumbnail ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        >
                            <img src={image.src} alt={`Thumbnail ${index + 1}`} />
                        </button>
                    ))}
                </div>

                {/* Dot indicators */}
                <div className="carousel-dots">
                    {images.map((_, index) => (
                        <button
                            key={index}
                            className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Carousel;
